import { render, staticRenderFns } from "./SwiperPeople.vue?vue&type=template&id=ddf3e54c&"
import script from "./SwiperPeople.vue?vue&type=script&lang=js&"
export * from "./SwiperPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports